import { render } from "./App.vue?vue&type=template&id=ac95bcac"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ac95bcac&lang=scss"
script.render = render

export default script